<script>
import { combine } from 'flubber';
import BezierEasing from 'bezier-easing';

const ease = BezierEasing(0.620, 0.240, 0.300, 0.790);

export default {
	props: {
		from: String,
		to: {
			type: String,
			default: 'icon-arrow',
		},
		state: String,
	},
	data() {
		return {
			allSvgs: null,
			viewBox: null,
			fromPaths: [],
			toPaths: [],
			domPath: null,
			t: 0,
			direction: 'normal',
			duration: 400,
			flubber: null,
		};
	},
	computed: {
		speed() {
			return 1 / (60 * (this.duration / 1000));
		},
		isIE() {
			return navigator.appName === 'Microsoft Internet Explorer'
				|| !!(navigator.userAgent.match(/Trident/)
				|| navigator.userAgent.match(/rv:11/));
		},
	},
	methods: {
		extractInfo(source) {
			const string = this.allSvgs(`./${this[source]}.svg`);
			const svg = document.createElement('div');
			svg.innerHTML = string;

			Array.from(svg.querySelectorAll('path')).forEach((path) => {
				if (!this.viewBox) {
					this.viewBox = svg.firstChild.attributes.viewBox.value;
				}

				this[`${source}Paths`].push(path.attributes.d.value);
			});
		},
		raf() {
			this.t += this.direction === 'normal'
				? this.speed
				: -this.speed;

			if (this.t > 0 && this.t < 1) {
				requestAnimationFrame(this.raf);
			}

			if (this.t <= 0) {
				this.t = 0;
			}

			if (this.t >= 1) {
				this.t = 1;
			}

			this.domPath.setAttribute('d', this.flubber(ease(this.t)));
		},
		unmorph() {
			this.direction = 'reverse';
			this.raf();
		},
		morph() {
			this.direction = 'normal';
			this.raf();
		},
	},
	created() {
		this.allSvgs = require.context('svgs/', true, /\.svg$/);

		if (!this.isIE) {
			this.extractInfo('from');
			this.extractInfo('to');

			this.flubber = combine(this.fromPaths, this.toPaths[0], { single: true });
		}
	},
	mounted() {
		this.domPath = this.$el.querySelector('path');

		if (!this.isIE) {
			this.domPath.setAttribute('d', this.flubber(0));

			this.$el.addEventListener('mouseenter', this.morph);
			this.$el.addEventListener('mouseleave', this.unmorph);
		}
	},
};
</script>

<template>
	<div class="ge-svg-hover">
		<svg
			v-if="!isIE"
			:class="['ge-svg-hover', {state}]"
			:viewBox="viewBox">

			<path></path>
		</svg>
		<sky-svg
			v-else
			class="fallback"
			:name="from"></sky-svg>
		<slot />
	</div>
</template>

<style src="./ge-svg-hover.scss"></style>



// WEBPACK FOOTER //
// ge-svg-hover.vue?a5514fe4